<div
  class="widget-quill-canvas"
  [ngClass]="verticalAlignment"
>
  <p-editor
    #editor
    [formControl]="textEditorFormControl"
    [ngClass]="{
      'toolbar-hidden': !active || chartOptions?.toolbar === false
    }"
    styleClass="tw-bg-[{{ backgroundColor }}]"
    (onInit)="onEditorInit($event)"
  >
    <ng-template pTemplate="header">
      <span class="ql-formats">
        <button
          type="button"
          class="ql-bold"
          aria-label="Bold"
        ></button>
        <button
          type="button"
          class="ql-italic"
          aria-label="Italic"
        ></button>
        <button
          type="button"
          class="ql-underline"
          aria-label="Underline"
        ></button>
        <select class="ql-size">
          <option
            *ngFor="let value of fontSizes"
            [value]="value"
            [attr.selected]="value === defaultFontSize ? true : null"
          >
            {{ value }}
          </option>
        </select>
        <select class="ql-align">
          <option selected></option>
          <option value="center"></option>
          <option value="right"></option>
          <option value="justify"></option>
        </select>
        <button
          type="button"
          class="ql-link"
          aria-label="Hyperlink"
        ></button>
        <select class="ql-color">
          <option
            [value]="color"
            *ngFor="let color of textColors"
          ></option>
          <option default></option>
        </select>
        <select class="ql-background">
          <option
            [value]="color"
            *ngFor="let color of textColors"
          ></option>
          <option default></option>
        </select>
        <button
          type="button"
          class="ql-image"
          aria-label="Insert Image"
        ></button>
      </span>
    </ng-template>
  </p-editor>
</div>

<dialog-template
  dialogId="linkDialog"
  header="Insert Link"
  primaryBtnText="Save"
  (primaryBtnClicked)="applyLink()"
  [primaryBtnDisabled]="!linkUrlControl.valid"
  appendTo="body"
>
  <ng-template #contentTemplate>
    <div class="tw-flex tw-flex-col tw-mb-5">
      <div class="tw-flex tw-items-center tw-gap-2">
        <input
          pInputText
          class="tw-flex-1"
          [formControl]="linkUrlControl"
          placeholder="https://"
        />
        <p-button
          label="Remove Link"
          (onClick)="removeLink()"
          severity="danger"
          class="tw-whitespace-nowrap"
        ></p-button>
      </div>
      <small
        class="tw-mt-1 tw-text-red-500"
        *ngIf="!linkUrlControl.valid"
      >
        Make sure the URL is valid.
      </small>
    </div>
  </ng-template>
</dialog-template>
